module.exports = __webpack_public_path__ + "static/media/16UNODC15.c513a580.jpg";